import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { AccountService } from 'src/modules/features/setting/services';
import { AuthenticationService } from 'src/modules/core/services';
import {
  ConfirmModal,
  CommonServices,
  SharedValidators,
  TwoFactorModal,
} from 'src/modules/shared';
import { environment } from 'src/environments/environment';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { NotificationService } from '../../services';
@Component({
  selector: 'app-account-security',
  templateUrl: './account-security.component.html',
  styleUrls: ['./account-security.component.scss'],
})
export class NotificationComponent implements OnInit {
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt;
  accountForm: FormGroup;
  user: any;
  organization: any;
  pending: boolean;
  error: any;
  success: any;
  image = 'assets/avatar/1.jpg';
  baseUrl: string = environment.API_SERVER;
  apps: Array<any> = [];
  isRestrictedEntity: boolean = false;
  constructor(
    private commonSvc: CommonServices,
    private authService: AuthenticationService,
    private modalService: SuiModalService,
    private location: Location,
    private notificationSvc: NotificationService,
    private builder: FormBuilder
  ) {
    this.user = JSON.parse(window.localStorage.getItem('user'));
    this.accountForm = this.builder.group(
      {
        oldPassword: ['', Validators.required],
        newPassword: [''],
        password: ['', [Validators.required, SharedValidators.strongPassword]],
        confirmPassword: [
          '',
          [Validators.required, SharedValidators.strongPassword],
        ],
      },
      {
        validator: SharedValidators.matchingPasswords(
          'password',
          'confirmPassword'
        ),
      }
    );
    const organization = JSON.parse(
      window.localStorage.getItem('organization')
    );
    if (organization.restrictedApplicationId) {
      this.isRestrictedEntity = true;
    }
    this.authService.user.subscribe((res) => {
      this.user = res;

      if (this.user && this.user.image) {
        this.image = `${
          this.baseUrl
        }/public/image/?media=${this.user.image.replace(/\\/g, '/')}`;
      }
      if (this.user) {
        if (this.isRestrictedEntity) {
          const restrictedApplicationId =
            this.user.organizationId.restrictedApplicationId.applicationId;
          this.apps = this.user['applications'].filter((item) => {
            return item.applicationId === restrictedApplicationId;
          });
        } else {
          this.apps = this.user['applications'];
        }
      }
    });
  }

  isFieldValid(field: string) {
    return (
      (!this.accountForm.get(field).valid &&
        this.accountForm.get(field).touched) ||
      (this.accountForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  toggle(event) {
    if (event == true) {
      this.modalService
        .open(
          new TwoFactorModal(
            'Two-factor Authentication',
            'Are you sure you want to delete this app config?',
            false,
            ModalSize.Tiny
          )
        )
        .onApprove(() => {})
        .onDeny(() => {});
    } else {
      this.modalService
        .open(
          new ConfirmModal(
            'Disable Two-factor Authentication?',
            'Are you sure you want to disable two-factor authentication?',
            ModalSize.Tiny
          )
        )
        .onApprove(() => {
          this.pending = true;
          this.commonSvc.disableTwoFactor().subscribe(
            (res) => {
              this.pending = false;
              this.success = '2-factor authentication disabled successfully';
              this.user['totpEnabled'] = false;
              window.localStorage.setItem('user', JSON.stringify(this.user));
            },
            (error) => {
              this.pending = false;
              this.error = error.error.errorMessage
                ? error.error.errorMessage
                : error.error
                ? error.error
                : error;
            }
          );
        })
        .onDeny(() => {
          this.user['totpEnabled'] = true;
        });
    }
  }
  submit() {
    this.pending = true;
    this.error = null;
    this.success = null;
    this.formSubmitAttempt = true;
    if (this.accountForm.valid) {
      this.notificationSvc
        .updateAppConfig({
          appUserId: this.user.appUserId,
          body: this.accountForm.value,
        })
        .subscribe(
          (res) => {
            this.pending = false;
            this.success = 'Application config successfully';
          },
          (error) => {
            this.pending = false;
            this.error = error.error.errorMessage
              ? error.error.errorMessage
              : error.error
              ? error.error
              : error;
          }
        );
    } else {
      this.formSubmitAttempt = true;
    }
  }

  goBack() {
    this.location.back();
  }
  ngOnInit(): void {}
  editUsername() {}
  editEmail() {}
}
